import '@hotmart/cosmos/dist/date-picker';
import { forwardRef, useEffect, useMemo } from 'react';
import { Portuguese } from 'flatpickr/dist/l10n/pt';
import { Spanish } from 'flatpickr/dist/l10n/es';

import { Language } from 'src/utils/constants';
import i18n from 'src/i18n';

import { CustomIcon } from '../Icon';

import { Wrapper, datePickerModal } from './styles';
import { useDatePickerRef } from './hooks';
import { DatePickerProps, HotDatePickerProps } from './types';

const DatePicker = forwardRef<JSX.IntrinsicElements['hot-date-picker'], DatePickerProps>(({ onChange, label, className, placeholder, icon, invalid, value, publishingDateRange, locale = Language.PT, dateFormat = 'DD/MM/YYYY' }, forwardedRef) => {
  const { ref } = useDatePickerRef(forwardedRef)
  const changeHandler = (e: Event) => onChange(e as CustomEvent)

  const customPickerProps = useMemo(() => ({
    invalid: invalid || undefined,
    placeholder: placeholder || undefined,
    date:  value || undefined,
    dateFormat
  }), [invalid, placeholder, value])

  const l10n = {
    'start-date-placeholder': i18n.t('forms.schedule_posts.date_picker.start_date_placeholder'),
    cancel: i18n.t('forms.schedule_posts.date_picker.buttons.cancel'),
    apply: i18n.t('forms.schedule_posts.date_picker.buttons.apply'),
  }

  useEffect(() => {
    const hotDatePicker = document.querySelector('hot-date-picker') as HotDatePickerProps | null;

    if (!hotDatePicker) return;

    hotDatePicker?.addEventListener('change', changeHandler);

    return () => {
      hotDatePicker?.removeEventListener('change', changeHandler);
    };
  }, [onChange]);

  useEffect(() => {
    const hotDatePicker = document.querySelector('hot-date-picker') as HotDatePickerProps | null;

    if (!hotDatePicker) return;

    if (locale.toLowerCase() === Language.PT) {
      hotDatePicker?.setLocale(Portuguese, l10n);
    } else if (locale.toLowerCase() === Language.ES) {
      hotDatePicker?.setLocale(Spanish, l10n);
    }

    publishingDateRange && hotDatePicker?.setEnabledDates([publishingDateRange]);
  }, []);

  useEffect(() => {
    const datePickerModalStyles = document.createElement('style')
    datePickerModalStyles.prepend(datePickerModal.toString())
    document?.querySelector('hot-date-picker-concrete')?.shadowRoot?.prepend(datePickerModalStyles)
  }, [])

  return (
    <Wrapper className={className}>
      {label ? (
        <label className='hot-form__label'>
          {label}
        </label>
      ):null}
      <div className='_position-relative'>
        {icon? <CustomIcon className='_text-gray-500 _position-absolute icon _mr-4' icon={icon} />: null}
        <hot-date-picker {...customPickerProps} ref={ref} class="_bg-transparent"></hot-date-picker>
      </div>
    </Wrapper>
  )
})

export default DatePicker